import { useEffect } from "react";
import { useAppDispatch } from "../redux-store";
import { updateNowUtc } from "../ducks/app/time";

const CurrentTimeProvider = ({ children }: { children: any }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateNowUtc());
    let interval = setInterval(() => {
      dispatch(updateNowUtc());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  return <div>{children}</div>;
};

export default CurrentTimeProvider;
